<template>
  <div class="content">
    <div class="top">
      <div class="setting">
        <!-- <div class="icon" @click="toKefu()">
          <van-image src="img/home/kefu.png" width="24"></van-image>
        </div> -->
      </div>
      <div class="info">
        <van-image round class="user_img" :src="userInfo.header_img">
          <template v-slot:error>
            <van-image src="img/nan/11.png"></van-image>
          </template>
        </van-image>
        <div class="user_info">
          <div class="user">
            <div>{{ userInfo.username }}</div>
            <van-image src="img/user/vip.png" width="90"></van-image>
          </div>
          <div class="score">{{ $t('user.label') }}: {{ changeMoney(userInfo.xinyufen) }}</div>
          <div class="line">
            <div class="process"><div class="inside"></div></div>
            <div class="label">{{ $t('user.process') }}{{ changeMoney(userInfo.total_recharge_money) }}</div>
            <div class="value"></div>
          </div>
        </div>
      </div>
    </div>


    <div class="center">
      <div class="card2">
        <div>
          <div class="balance-label"> {{$t("user.balance")}} </div>
          <div class="jiner"> {{changeMoney(this.userInfo.money)}} </div>
        </div>
        <div class="balance-side">
          <span class="font-28 font-gray">{{$t("user.unit")}}</span>
          <div class="refresh-btn">
            <i class="van-icon van-icon-replay"><!----></i>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="left" @click="goPage('/Tx')">
          <van-image src="img/user/top_icon1.png" width="22"></van-image>
          <div>{{ $t("user.recharge") }}</div>
        </div>
        <div class="right" @click="doWithdrawal()">
          <van-image src="img/user/top_icon2.png" width="22"></van-image>
          <div>{{ $t("user.withdraw") }}</div>
        </div>
      </div>

      <div class="card3">
        <div class="block" v-for="(item, index) in menuList" :key="index" @click="goPage(item.url)">
          <van-image :src="item.icon" width="26"></van-image>
          <div class="label">{{ item.label }}</div>
        </div>
      </div>

      <div class="btn" @click="loginout()">{{ $t('user.logout') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{},
      menuList: [
        { label: this.$t("user.icon1"), icon: '/img/user/icon1.png', url: '/Info' },
        { label: this.$t("user.icon8"), icon: '/img/user/icon2.png', url: '/Jifen' },
        { label: this.$t("user.icon3"), icon: '/img/user/icon3.png', url: '/Liushui' },
        { label: this.$t("user.icon4"), icon: '/img/user/icon4.png', url: '/GameRecord' },
        { label: this.$t("user.icon5"), icon: '/img/user/icon5.png', url: '/Notice' },
        { label: this.$t("user.icon6"), icon: '/img/user/icon6.png', url: '/MyMove' },
        { label: this.$t("user.icon2"), icon: '/img/user/icon7.png', url: '/SetLoginPassword' },
        { label: this.$t("user.icon7"), icon: '/img/user/icon8.png', url: '/SetPayPassword' },
      ],
      isLoading: false,
    };
  },
  methods: {
    goPage(url) {
      this.$router.push({ path: url })
    },
    refresh(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t("reservation.refresh"));
        }else{
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    exit(){
      this.$router.push("Setbank");
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doPay(){
      this.$router.push({
        name:'Recharge',
        params:{
          'balance':this.userInfo.money
        }
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        console.log(res)
          if(res.data.is_bank){
            this.$router.push("withdraw");
          }else {
            this.$router.push("bindCard");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
      })
    },
    toService(){
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("Tx");
      }else {
        this.$router.push("Tx");
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    toKefu() {
      console.log(this.$store.getters.getBaseInfo)
      window.open(this.$store.getters.getBaseInfo.kefu)
      // this.$router.push("ServiceOnline");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          console.log(res)
            this.userInfo = res.data;
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    loginout(){
        localStorage.clear()
        this.$router.push({path:'/Login'});
    },
    
    // 价格转换（加逗号）
    changeMoney: (money, type = 'us') => {
      if (isNaN(Number(money))) {
        return '-'
      }
      money = Number(money).toFixed(0)
      const unit1 = type === 'tur' ? '.' : ','
      const x = money.split('.')
      let x1 = x[0]
      const reg = /(\d+)(\d{3})/
      while (reg.test(x1)) {
        x1 = x1.replace(reg, '$1' + unit1 + '$2')
      }
      return `${x1}`
    }
  },
  created() {
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.content{
  background: @bg-page;
  overflow: auto;
  height: 100%;
  padding-bottom: 3.2rem;
}

.top{
  height: auto;
  background: @bg-page;
  border-bottom: none;
  overflow: hidden;
  padding: 1.35rem 1.25rem 0.2rem;
  .setting {
    height: 0;
    display: flex;
    justify-content: end;
  }

  .info {
    margin-top: 0;
    padding: 0;
    display: flex;
    align-items: center;
    .user_img {
      height: 4.2rem;
      width: 4.2rem;
      flex-shrink: 0;
      border: 1px solid @gold;
      box-shadow: none;
      ::v-deep img {
        border-radius: 50%;
      }
    }
    .user_info{
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 0 0 0.95rem;
      .user{
        display: flex;
        align-items: center;
        div{
          color: @text-title;
          font-size: 1.15rem;
          font-weight: 600;
          letter-spacing: 0.02rem;
          margin-right: 0.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        ::v-deep .van-image {
          width: 4.2rem !important;
          flex-shrink: 0;
        }
      }
      .score{
        margin: 0.28rem 0 0.35rem;
        font-size: 0.84rem;
        color: @text-sub;
      }
      .line{
        display: block;
        .process{
          width: 100%;
          height: 0.16rem;
          margin: 0.15rem 0 0.32rem;
          border-radius: 0;
          background: #efe8db;
          .inside{
            width: 80%;
            background: @gold;
            height: 0.16rem;
            border-radius: 0;
          }
        }
        .label,.value{
          font-size: 0.78rem;
          color: @text-sub;
          line-height: 1.35;
        }
      }
    }
  }
}

.center{
  width: 100%;
  margin: 0;
  padding: 0.35rem 1.25rem 1.5rem;
  .card1{
    background: transparent;
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding: 0.85rem 0 0;
    display: flex;
    >div{
      flex: 1;
      height: 3.15rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: @text-title;
      font-weight: 500;
      background: @bg-card;
      border: 1px solid @line;
      border-radius: 0.08rem;
    }
    .left {
      margin-right: 0.7rem;
    }
    .right {
      border-color: @wine;
      color: @wine;
    }
    .van-image{
      margin-right: 0.45rem;
    }
  }

  .card2{
    background: @bg-card;
    box-shadow: none;
    border: 1px solid @line;
    border-left: 0.16rem solid @gold;
    margin-top: 1.15rem;
    border-radius: 0;
    height: auto;
    min-height: 5.2rem;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: @text-title;
    padding: 0.95rem 1rem;

    .balance-label {
      font-size: 0.78rem;
      letter-spacing: 0.08rem;
      color: @text-sub;
      margin-bottom: 0.35rem;
    }
    .balance-side {
      display: flex;
      align-items: center;
    }
    .refresh-btn {
      margin-left: .7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.55rem;
      height: 1.55rem;
      font-size: .9rem;
      border-radius: 50%;
      color: @gold-deep;
      background-color: transparent;
      border: 1px solid @line-gold;
    }
    span{
      color: @gold-deep;
      font-size: .84rem;
    }
    .jiner {
      font-size: 1.65rem;
      font-weight: 600;
      letter-spacing: 0.02rem;
      color: @text-title;
    }
  }

  .card3{
    background: @bg-card;
    border: 1px solid @line;
    width: 100%;
    display: flex;
    padding: 0;
    align-items: stretch;
    flex-wrap: wrap;
    border-radius: 0;
    box-shadow: none;
    margin-top: 1rem;
    >div{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0.95rem 0.95rem;
      border-bottom: 1px solid @line;
      &:last-child {
        border-bottom: none;
      }
      .van-image {
        width: 1.3rem !important;
        height: 1.3rem !important;
        margin-right: 0.75rem;
        border-radius: 0;
        background: transparent;
        border: none;
        display: flex !important;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        ::v-deep .van-image__img {
          width: 1.3rem !important;
          height: 1.3rem !important;
          position: static !important;
          object-fit: contain;
        }
      }
      &::after {
        content: '';
        margin-left: auto;
        width: 0.4rem;
        height: 0.4rem;
        border-top: 1px solid #c2b49a;
        border-right: 1px solid #c2b49a;
        transform: rotate(45deg);
        flex-shrink: 0;
      }
    }
    .label {
      color: @text-title;
      padding: 0;
      text-align: left;
      line-height: 1.3;
      font-size: 0.95rem;
      word-break: break-word;
    }
  }

  .btn{
    width: 100%;
    background: transparent;
    box-shadow: none;
    color: @wine;
    border: 1px solid rgba(140, 47, 57, 0.4);
    font-weight: 600;
    letter-spacing: 0.06rem;
    padding: 0.9rem 0;
    border-radius: 0.08rem;
    font-size: .93rem;
    cursor: pointer;
    margin: 1.35rem auto 2.4rem;
    text-align: center;
  }
}

.user_top {
    width: 92%;
    margin: 0 auto;
    margin-top: 6.25rem;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
    .user_img {
    height: 3.75rem;
    width: 3.75rem;
    border: 0.06rem solid #ff1a6d;
  }
  .ro {
    color: #fff;
    background: linear-gradient(90deg, #5820ff, #ff1a6d);
    border-radius: 1.25rem;
    display: flex;
    justify-content: space-between;
    padding-left: 3%;
    padding-right: 3%;
    align-items: center;
    font-size: .6875rem;
    padding-top: 1%;
    padding-bottom: 1%;
    .huang {
      width: 1.09375rem;
      height: .9375rem
    }
  }
}

.but {
  display: flex;
  width: 92%;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 5%;
  margin-bottom: 5%;
  .chong, .tx {
    width: 48%;
    background-size: 100% 100%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    color: #fff;
  }
  .tx_img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 10%;
  }
  .chong {
    background-image: url('@/assets/imgs/mine/2.png');
  }
  .tx {
    background-image: url('@/assets/imgs/mine/1.png');
  }

}

.yue {
  width: 92%;
  margin: 0 auto;
  background-image: url('@/assets/imgs/mine/yue.png');
  background-size: 100% 100%;
  height: 6rem;
  margin-bottom: 2%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 4%;
  padding-bottom: 4%;

  .refresh-btn {
    margin-left: .9375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5625rem;
    height: 1.5625rem;
    font-size: .9375rem;
    border-radius: 50%;
    color: #fff;
    background-color: #c24491;
  }
  .font-gray {
    color: #fff;
  }
  .font-28 {
    font-size: .875rem;
  }
  .jiner {
    font-size: 1.3rem;
  }
}
.menu {
  width: 92%;
  background: #22063a;
  margin: 0 auto;
  margin-top: 5%;
  border-radius: 0.63rem;
  display: flex;
  flex-wrap: wrap;
  padding-left: 3%;
  padding-right: 3%;
  border: 0.06rem solid #c36dfe;
  .row{
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding-top: 2%;
    padding-bottom: 2%;
    .left{
      display: flex;
      align-items: center;
      img{
        width: 2.65625rem;
        height: 2.8125rem;
      }
      .label{
        color: #fff;
        font-size: .9rem;
      }
    }
  }
  .line{
    width: 100%;
    height: .0625rem;
    background: #fff;
    opacity: .12;
  }
}
.kefu{
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 2rem;
}
</style>
